export const handleComparing = ({
  selectedDrawings,
  handleCloseCompareModal,
}) => {
  console.log(selectedDrawings);
  const sortedDrawings = selectedDrawings.sort(
    (a, b) => a.revision - b.revision,
  );

  const comparedDrawing = {
    name: sortedDrawings[0]?.name || "",
    sheetNumber: sortedDrawings[0]?.sheetNumber || "",
    revs: [],
    ids: [],
    comparedMaterials: [],
    v1: [],
    v2: [],
  };

  /// get Revisions
  sortedDrawings.forEach((drawing) => {
    if (drawing?.name !== comparedDrawing?.name) {
      handleCloseCompareModal();
      alert("Please select Revisions of the same Drawing ! ");
    }

    if (drawing?.sheetNumber !== comparedDrawing?.sheetNumber) {
      handleCloseCompareModal();
      alert("Please select Revisions of the same Sheet ! ");
    }

    comparedDrawing.revs.push(drawing.revision);
    comparedDrawing.ids.push(drawing.id);
  });

  //// Compare Materials
  const d1 = sortedDrawings[0]?.materials.sort((a, b) => a.item - b.item) || [];
  const d2 = sortedDrawings[1]?.materials.sort((a, b) => a.item - b.item) || [];

  const requiredKeys = ["description", "quantity", "length"];

  comparedDrawing.comparedMaterials = d1.map((item1) => {
    const item2 = d2.find((d) => d.item === item1.item);

    if (!item2) return { ...item1, comparingState: "deleted" };

    // default: unchanged unless we find a mismatch
    let mergedItem = { ...item1, comparingState: "unchanged" };

    for (const key of requiredKeys) {
      if (item1[key] !== item2[key]) {
        mergedItem = {
          ...item1,
          comparingState: "changed",
          comparingKey: key,
          comparingValue1: item1[key],
          comparingValue2: item2[key],
        };
        break; // ✅ stop on first change
      }
    }

    return mergedItem;
  });

  comparedDrawing.v1 = d1.map((item1) => {
    const item2 = d2.find((d) => d.item === item1.item);

    if (!item2) return { ...item1, comparingState: "deleted" };

    let mergedItem = { ...item1, comparingState: "unchanged" };

    for (const key of requiredKeys) {
      if (item1[key] !== item2[key]) {
        mergedItem = { ...item1, comparingState: "changed" };
        break; // ✅ stop on first change
      }
    }

    return mergedItem;
  });

  comparedDrawing.v2 = d2.map((item2) => {
    const item1 = d1.find((d) => d.item === item2.item);

    if (!item1) return { ...item2, comparingState: "added" };

    let mergedItem = { ...item2, comparingState: "unchanged" };

    for (const key of requiredKeys) {
      if (item2[key] !== item1[key]) {
        mergedItem = {
          ...item2,
          comparingState: "changed",
          comparingKey: key,
          comparingValue1: item2[key],
          comparingValue2: item1[key],
        };
        break; // ✅ stop on first change
      }
    }

    return mergedItem;
  });

  console.log("compareddddd", comparedDrawing);
  return comparedDrawing;
};
